import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "@/lib/i18n";
import { CartProvider } from "@/lib/cart";
import { AuthProvider, ProtectedRoute } from "@/lib/auth";

import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import BookList from "@/pages/BookList";
import BookDetails from "@/pages/BookDetails";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import TrackOrder from "@/pages/TrackOrder";
import JobCirculars from "@/pages/JobCirculars";
import JobCircularDetails from "@/pages/JobCircularDetails";
import Winners from "@/pages/Winners";
import Blog from "@/pages/Blog";
import BlogDetails from "@/pages/BlogDetails";
import OfflineStore from "@/pages/OfflineStore";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminBooks from "@/pages/admin/AdminBooks";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminLibraries from "@/pages/admin/AdminLibraries";
import AdminJobCirculars from "@/pages/admin/AdminJobCirculars";
import AdminWinners from "@/pages/admin/AdminWinners";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminHeroSlider from "./pages/admin/AdminHeroSlider";
import ScrollToTop from "./components/site/ScrollToTop";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import ForgotPassword from "./pages/ForgotPassword";
import AdminPayments from "./pages/admin/AdminPayments";

function App() {
    return (
        <div className="App font-bn">
            <I18nProvider>
                <CartProvider>
                    <BrowserRouter>
                        <AuthProvider>
                            <ScrollToTop />
                            <Routes>
                                <Route element={<SiteLayout />}>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/books/:category" element={<BookList />} />
                                    <Route path="/book/:id" element={<BookDetails />} />
                                    <Route path="/cart" element={<Cart />} />
                                    <Route path="/checkout" element={<Checkout />} />
                                    <Route path="/order-success/:orderNumber" element={<OrderSuccess />} />
                                    <Route path="/track" element={<TrackOrder />} />
                                    <Route path="/job-circulars" element={<JobCirculars />} />
                                    <Route path="/job-circulars/:id" element={<JobCircularDetails />} />
                                    <Route path="/winners" element={<Winners />} />
                                    <Route path="/blog" element={<Blog />} />
                                    <Route path="/blog/:id" element={<BlogDetails />} />
                                    <Route path="/offline-store" element={<OfflineStore />} />
                                    <Route path="/register" element={<Register />} />
                                    <Route path="/login" element={<Login />} />
                                    <Route path="/forgot-password" element={<ForgotPassword />} />

                                    <Route
                                        path="/profile"
                                        element={
                                            <ProtectedRoute role="customer">
                                                <Profile />
                                            </ProtectedRoute>
                                        }
                                    />
                                </Route>

                                <Route path="/admin/login" element={<AdminLogin />} />

                                <Route
                                    path="/admin"
                                    element={
                                        <ProtectedRoute role="admin">
                                            <AdminLayout />
                                        </ProtectedRoute>
                                    }
                                >
                                    <Route index element={<AdminOverview />} />
                                    <Route path="hero-slider" element={<AdminHeroSlider />} />
                                    <Route path="books" element={<AdminBooks />} />
                                    <Route path="categories" element={<AdminCategories />} />
                                    <Route path="orders" element={<AdminOrders />} />
                                    <Route path="libraries" element={<AdminLibraries />} />
                                    <Route path="job-circulars" element={<AdminJobCirculars />} />
                                    <Route path="winners" element={<AdminWinners />} />
                                    <Route path="blog" element={<AdminBlog />} />
                                    <Route path="newsletter" element={<AdminNewsletter />} />
                                    <Route path="settings" element={<AdminSettings />} />
                                    <Route path="payments" element={<AdminPayments />} />
                                </Route>
                            </Routes>
                        </AuthProvider>
                    </BrowserRouter>
                </CartProvider>
            </I18nProvider>
        </div>
    );
}

export default App;
